<p-dialog maskStyleClass="backdrop-blur-sm" [(visible)]="visible" [modal]="true" [style]="{ width: '500px' }">
  <ng-template #header>
    <h1 class="text-2xl font-semibold">User Profile</h1>
  </ng-template>
  @if (loading) {
    <div class="flex flex-col rounded-2xl">
      <div class="flex flex-col items-center mb-4">
        <p-skeleton shape="circle" size="15rem" styleClass="mb-4" />
        <p-skeleton width="12rem" height="2.5rem" styleClass="mb-2" borderRadius="8px" />
      </div>
      <p-divider></p-divider>
      <p-skeleton width="100%" height="3rem" styleClass="mt-10 mb-2" borderRadius="8px" />
      <p-skeleton width="100%" height="3rem" styleClass="mt-6 mb-2" borderRadius="8px" />
      <div class="flex items-center justify-between mt-3 mb-2">
        <p-skeleton width="6rem" height="2rem" borderRadius="8px" />
        <p-skeleton width="8rem" height="2rem" borderRadius="8px" />
      </div>
      <p-divider class="mt-6"></p-divider>
      <div class="flex items-center justify-center gap-6 mt-10">
        <p-skeleton width="6rem" height="2.5rem" borderRadius="8px" />
        <p-skeleton width="6rem" height="2.5rem" borderRadius="8px" />
      </div>
    </div>
  } @else {
    <form #profileForm="ngForm" (ngSubmit)="saveChanges(profileForm)">
      <div class="flex flex-col rounded-2xl">
        <div class="flex flex-col items-center mb-4">
          <img [src]="avatarUrl"
            alt="User Avatar"
            class="rounded-full w-64 h-64 mb-2">
            <p-button
              icon="pi pi-upload"
              label="Upload Avatar"
              styleClass="mt-2"
              (click)="showAvatarModal()">
            </p-button>
          </div>
          <p-divider></p-divider>
          <p-floatlabel variant="on" class="mt-10">
            <input
              pInputText
              id="on_user_name"
              name="displayName"
              [(ngModel)]="displayName"
              autocomplete="off"
              required
              minlength="3"
              #displayNameCtrl="ngModel"
              fluid
              />
              <label for="on_user_name">User Name</label>
            </p-floatlabel>
            @if (displayNameCtrl.invalid && (displayNameCtrl.dirty || profileForm.submitted)) {
              <small class="text-red-600 mt-2">
                User Name is required and must be at least 3 characters long.
              </small>
            }
            <p-floatlabel variant="on" class="mt-6">
              <input
                pInputText
                id="on_user_email"
                name="email"
                [(ngModel)]="email"
                autocomplete="off"
                required
                email
                #emailCtrl="ngModel"
                disabled="true"
                fluid
                />
                <label for="on_user_email">Email</label>
              </p-floatlabel>
              @if (emailCtrl.invalid && (emailCtrl.dirty || profileForm.submitted)) {
                <small class="text-red-600 mt-2">
                  Please enter a valid email address.
                </small>
              }
              <div class="flex items-center justify-between mt-4 mb-2">
                <label>Email Visibility</label>
                <div>
                  <p-selectbutton
                    [(ngModel)]="shareEmail"
                    name="shareEmail"
                    [options]="[{ label: 'Show', value: true }, { label: 'Hide', value: false }]"
                    optionLabel="label"
                    optionValue="value"
                    class="flex-1"
                    allowEmpty="false"
                  ></p-selectbutton>
                </div>
              </div>
              <p-divider class="mt-6"></p-divider>
              <div class="flex items-center justify-center gap-6 mt-10">
                <p-button
                  icon="pi pi-times"
                  label="Cancel"
                  (click)="closeDialog()"
                  severity="secondary"
                  variant="outlined"
                  styleClass="w-full"
                  type="button"
                ></p-button>
                <p-button
                  icon="pi pi-save"
                  label="Save"
                  severity="primary"
                  styleClass="w-full"
                  type="submit"
                  [disabled]="!profileForm.valid || !profileForm.dirty"
                ></p-button>
              </div>
            </div>
          </form>
        }
      </p-dialog>

      <p-dialog
        [(visible)]="showAvatarUploadModal"
        header="Upload New Avatar"
        [modal]="true"
        [closable]="true"
        [style]="{ width: '400px' }">
        <div>
          @if (!croppedImage) {
            <p-fileUpload
              mode="basic"
              name="avatar"
              accept="image/*"
              (onSelect)="onAvatarSelected($event)"
              chooseLabel="Select Image">
            </p-fileUpload>
          }
          @if (imageFile) {
            <image-cropper
              [imageFile]="imageFile"
              format="webp"
              [resizeToWidth]="256"
              [resizeToHeight]="256"
              [onlyScaleDown]="true"
              (imageCropped)="imageCropped($event)"
              (imageLoaded)="imageLoaded()"
              (cropperReady)="cropperReady()"
              (loadImageFailed)="loadImageFailed()">
            </image-cropper>
          }
          @if (croppedImage) {
            <img [src]="croppedImage" class="rounded-full w-64 h-64 mt-4 mx-auto" alt="Cropped Avatar Preview">
          }
        </div>
        <div class="flex items-center justify-center gap-6 mt-10">
          <p-button
            label="Cancel"
            icon="pi pi-times"
            severity="secondary"
            styleClass="w-full"
            variant="outlined"
            type="button"
            (click)="showAvatarUploadModal = false"
          ></p-button>
          <p-button
            label="Confirm"
            icon="pi pi-check"
            styleClass="w-full"
            type="button"
            [disabled]="!croppedBlob"
            (click)="confirmAvatarCrop()"
          severity="primary"></p-button>
        </div>
      </p-dialog>